import React from "react";
import CisoExecutiveDashboard from "components/newDesign/dashboard/CisoExecutiveDashboard";

const CDashboard = () => {
  return <CisoExecutiveDashboard />;
};

export default CDashboard;
